import { isNotNil } from "@utils/assert";
import React, { ReactNode, useEffect } from "react";

interface WindowFocusHandlerProps {
	onFocus?: () => void;
	onBlur?: () => void;
	children: ReactNode;
}

export const WindowFocusHandler: React.FC<WindowFocusHandlerProps> = ({ onFocus = null, onBlur = null, children }) => {
	useEffect(() => {
		if (isNotNil(onFocus)) {
			window.addEventListener("focus", onFocus);
		}
		if (isNotNil(onBlur)) {
			window.addEventListener("blur", onBlur);
		}

		// Calls onFocus when the window first loads
		onFocus?.();

		// Specify how to clean up after this effect:
		return () => {
			if (isNotNil(onBlur)) {
				window.removeEventListener("blur", onBlur);
			}
			if (isNotNil(onFocus)) {
				window.removeEventListener("focus", onFocus);
			}
		};
	}, [onBlur, onFocus]);

	return <>{children}</>;
};
